import { varConditionSchema } from '../conditional.zod';
import { cellCfgAttrsBaseSchema, cellCfgBaseSchema } from './cell-base.zod';

import z from 'zod';

const workOrderModalSchema = cellCfgAttrsBaseSchema.extend({
    writeVarId: z.string().min(1),
    /** This condition encompasses both the 'show modal' logic and 'requery' logic into one conditional. If true, show the modal if not already showing and perform the modal query */
    activateCondition: varConditionSchema,
});

export const workOrderModal = cellCfgBaseSchema.extend({
    type: z.literal('workOrderModal'),
    attrs: z.preprocess(v => {
        if (typeof v === 'object' && v && 'showCondition' in v) {
            const showCondition = v.showCondition;
            if (typeof showCondition === 'object' && showCondition) {
                return {
                    ...v,
                    activateCondition: showCondition,
                };
            }
        }
        return v;
    }, workOrderModalSchema),
});
